'use client';

import { Box } from '@chakra-ui/react';
import { PageContainer } from 'components';
import { OutletsMap } from 'components/OutletsMap';
import { usePageTextContent } from 'context/pageTextContent';
import { NetworkProfile } from './NetworkProfile';

interface Props {
  network: AdaptedNetworkWithOutlets;
}

export type NetworkProfilePageProps = Props;

export const NetworkProfilePageBase = (props: Props) => {
  const { network } = props;

  const { content } = usePageTextContent<NetworkProfilePage>();

  return (
    <PageContainer isFullHeight pos="relative" direction="column" bg="gray.50">
      <OutletsMap outlets={network.outlets} content={content} />

      <Box
        pos={['unset', 'unset', 'absolute']}
        left={['unset', 'unset', '9.375rem']}
        top={['unset', 'unset', '50%']}
        transform={['unset', 'unset', 'translateY(-50%)']}
        py={['5rem', '5rem', 'unset']}
        px={['1.75rem', '1.75rem', 'unset']}
      >
        <NetworkProfile network={network} />
      </Box>
    </PageContainer>
  );
};
